import { Typography } from '@navi/web-ui/lib/primitives';
import AutocompleteDropdown from '@cp/src/components/AutocompleteDropdown/AutocompleteDropdown';
import { noop } from '@tanstack/react-table';
import { MultiSelectErrorSectionProps } from '../../interface';
import { getDropdownOptions } from '../../utils';

const MultiSelectErrorSection = (props: MultiSelectErrorSectionProps) => {
  const { question, selectedOptions, onSelectionChange } = props;

  return (
    <div className="flex flex-col gap-2 p-3">
      <Typography variant="p4" color="var(--grayscale-2)">
        {question.question_text}
      </Typography>
      <AutocompleteDropdown
        options={getDropdownOptions(question.options)}
        selectedOptions={selectedOptions}
        placeholder={selectedOptions.length > 0 ? '' : 'Add type of error'}
        onSearch={noop}
        onSelectionChange={onSelectionChange}
        maxSelectedChipToShow={3}
        selectedOptionWrapperClass="bg-[var(--bg-blue)] border-[var(--blue-border)]"
        selectedOptionLabelClass="text-[var(--blue-base)]"
        selectedOptionChipIconColor="var(--blue-base)"
      />
    </div>
  );
};

export default MultiSelectErrorSection;
